import React from 'react'
import { SimpleLayout } from '../../layouts/simple'
import { Teacher } from '../../providers/context'
import { TeacherInfoTab } from './tabs/teacherInfoTab'
import { Button } from '../../components/simple/button'
import { Divider } from '../../components/simple/divider'
import { IconCaretLeft, IconCaretRight } from '../../icons/library'

export const TeacherInfoPage: React.FC<{ user: Teacher; id: number }> = ({ user, id }) => {
  return (
    <SimpleLayout>
      <div className="mx-auto mt-8 flex max-w-[80%] flex-col gap-2">
        <div className="self-center text-2xl font-bold">Review teacher info</div>

        <div className="max-w-[50%] self-center">
          Before sending out invites, you should make sure all teachers who families will be invited to meet with have
          their meeting location set. If a teacher does not have a location set, invited families may be confused.
        </div>
        <TeacherInfoTab user={user} conferenceID={id} />
        <Divider />
        <div className="mt-4 flex items-center gap-8 self-center">
          <Button link={`/ptc/adminConferenceVerification/verifyInvites/${id}`}>
            <IconCaretLeft /> Back to Verify Invites
          </Button>
          <Button logo link={`/ptc/conference/${id}#invite`}>
            Return To Conference <IconCaretRight />
          </Button>
        </div>
      </div>
    </SimpleLayout>
  )
}
